<div class="modal-header">
    <div class="title">
        <h2 class="modal-title-prefix"><span translate="PAYMENT.SINGULAR"></span></h2>
    </div>
</div>
<div class="modal-body">
    <form [formGroup]="baseFormGroup" class="">
        <div class="row">
            <div class="col-md-6">
                <yt-fw-date-picker-popup formControlName="DatumUplate" name="txtDatUpl" 
                    [Label]="'PAYMENT.DATE.SINGULAR'"
                    (OnDateSelected)="onDatumChange($event)"
                    [ngClass]="{'is-invalid': submitted && fc.DatumUplate.invalid}">
                </yt-fw-date-picker-popup>
            </div>
            <div class="col-md-6">
                <yt-number-input-v3 name="txtIznos" 
                [Label]="'PAYMENT.AMOUNT.SINGULAR'" formControlName="IznosUplate">
                </yt-number-input-v3>
            </div>
        </div>
    </form>
</div>
<div class="modal-footer">
    <button type="submit" class="btn btn-primary" id="btnOk" (click)="Ok()"><span
            translate="FW.ACTION.OK"></span></button>
    <button type="button" class="btn btn-secondary" id="btnClose" (click)="Close()"><span
            translate="FW.ACTION.CLOSE.ACTION"></span></button>
</div>